import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { PageContainer as PageContainerView } from "app/pages/industry-analysis/common/styledComponents";

const { carbon } = colorsPalettes;

const DEFAULT_MARGIN = "24px";
const MONITORS_BREAK = "1400px";

export const PageContainer = PageContainerView;

export const MarketSizeAndIndicatorsContainer = styled.div`
    display: grid;
    grid-template-columns: 35% calc(65% - ${DEFAULT_MARGIN});
    @media (max-width: ${MONITORS_BREAK}) {
        grid-template-columns: 336px auto;
    }
    gap: ${DEFAULT_MARGIN};
`;

export const MarketSizeSectionTitle = () => (
    <Text
        fontVariant="h5"
        color={carbon[500]}
        data-automation="market-size-section-title"
    >
        {translate("market.research.overview.sections.size")}
    </Text>
);

export const MarketShareSectionTitle = () => (
    <Text
        as="div"
        fontVariant="h5"
        color={carbon[500]}
        margin="8px 0 0 0"
        data-automation="market-share-section-title"
    >
        {translate("market.research.overview.sections.share")}
    </Text>
);

export const MarketAssessmentSectionTitle = () => (
    <Text
        as="div"
        fontVariant="h5"
        color={carbon[500]}
        margin="8px 0 0 0"
        data-automation="market-assessment-section-title"
    >
        {translate("market.research.overview.sections.assessment")}
    </Text>
);

export const ConversionRateSectionTitle = () => (
    <Text
        fontVariant="h5"
        color={carbon[500]}
        data-automation="conversion-rate-section-title"
    >
        {translate("market.research.overview.sections.conversion")}
    </Text>
);
